import { AxiosResponse } from "axios";
import { Transshipment } from "../models/transshipment";
import BaseService from "./_base.service";
import { Order } from "../models/order";
import API from "../api";
import { GetAndCountAll } from "./_base";
import { IUpdateAssigneeLeader } from "../pages/private/Moving/Warehousing/Transshipments/hooks/useActions";

const endpoint = "transshipments";

const TransshipmentService = {
  ...BaseService<Transshipment>({ endpoint }),
  async getOrders(options?: any): Promise<AxiosResponse<GetAndCountAll<Order>>> {
    return await API.get(`/${endpoint}/get/orders`, { params: options });
  },
  async getEditTransshipment(id?: number): Promise<AxiosResponse<Transshipment>> {
    return await API.get(`/${endpoint}/get/edit/screen/${id}`);
  },

  async updateStatus(data: Pick<Transshipment, 'status'>, id?: number): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${endpoint}/update/status/${id}`, data);
  },

  async updateAssigneeLeader({ leaderId, transshipmentId }: IUpdateAssigneeLeader) {
    return await API.put(`/${endpoint}/change-assignee`, {leaderId, transshipmentId});
  },
};

export default TransshipmentService;
